'use client'

// React Imports
import type { MouseEvent } from 'react'
import { useRef } from 'react'

// Next Imports
import { useRouter } from 'next/navigation'

// MUI Imports
import Button from '@mui/material/Button'

// Hook Imports

import { useRuangDialog } from '@/contexts/RuangDialogContext'

const UserDropdown = ({ dataSession }: { dataSession: any }) => {
  const anchorRef = useRef<HTMLDivElement>(null)
  const router = useRouter()

  const handleDropdownClose = (event?: MouseEvent<HTMLLIElement> | (MouseEvent | TouchEvent), url?: string) => {
    if (url) {
      router.push(url)
    }

    if (anchorRef.current && anchorRef.current.contains(event?.target as HTMLElement)) {
      return
    }
  }

  const { openDialog } = useRuangDialog()

  return (
    <>
      <div className='flex flex-col items-center'>
        <Button
          variant='outlined'
          color='secondary'
          size='small'
          component='div'
          onClick={e => {
            handleDropdownClose(e)
            openDialog()
          }}
          ref={anchorRef}
          sx={{
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: '4vh',
            width: { xs: '100%', sm: 'auto' },
            minWidth: '125px',
            maxWidth: '275px',
            height: '4vh',
            fontSize: '2vh',
            padding: '0 1rem',
            color: 'white', // teks putih
            borderColor: 'white', // border putih
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.1)', // efek hover transparan
              borderColor: 'white'
            }
          }}
        >
          Setting Ruangan
        </Button>
      </div>
    </>
  )
}

export default UserDropdown
